import React from 'react';
import { Redirect } from 'react-router-dom';
import groupings from '../../Common/Constants/Groupings';
import { isNullUndefinedOrEmpty } from '../../utils';
import useGrouping from 'Common/Utils/Hooks/useGrouping';
import MarkersAppointeeManagement from './Markers/AppointeeManagement.container';
import GenericAppointeeManagement from './Generic/AppointeeManagement.container';

const AppointeeManagementContainer = (props) => {
	document.title = "Contract Management - Appointee Management Menu";
	const grouping = useGrouping();
	if (isNullUndefinedOrEmpty(grouping)) {
		return <Redirect push to="/"></Redirect>;
	}

	return grouping === groupings.Marker
		? <MarkersAppointeeManagement grouping={grouping} {...props} />
		: <GenericAppointeeManagement grouping={grouping} {...props} />;
};

export default AppointeeManagementContainer;
